<script>
import moment from "moment";
import Swal from "sweetalert2";

// Custom components
import GeneralDetails from "@/components/BookingDetails/GeneralDetails.vue";
import Payment from "@/components/BookingDetails/Payment.vue";
import Questionnaire from "@/components/BookingDetails/Questionnaire.vue";
import ActivityLog from "@/components/BookingDetails/ActivityLog.vue";
import SMSChat from "@/components/BookingDetails/SmsChat.vue";
import UpSell from "@/components/BookingDetails/UpSell.vue";

import BookingService from "@/helpers/APIService/booking.service";
import errorHandler from "@/helpers/errorHandler";
import Middleware from "@/helpers/middlewares";
import { authComputed } from "@/state/helpers";

export default {
  components: {
    GeneralDetails,
    Payment,
    Questionnaire,
    ActivityLog,
    SMSChat,
    UpSell,
    // Folio,
  },
  props: {
    currentProps: Object,
  },
  data() {
    return {
      customQuestions: [],
      booking: null,
      bookingStatus: [],
      no_show_item: "",
      payment_id_sd: "",
      authFolio: [],
      chargeFolio: [],
      paymentData: {},
      beforeChangeStatus: "",
    };
  },
  computed: {
    ...authComputed,
    customQuestionProps() {
      return this.customQuestions;
    },
    detailProps() {
      return {
        booking: this.booking,
      };
    },
  },
  async created() {
    await this.setValues();
  },
  mounted() {
    this.$root.$on("UpdateRoom", (data) => {
      this.booking = {
        ...this.booking,
        allotted_room: data.allotted_room,
      };
    });
  },
  methods: {
    //Method is used for copy code
    copyCode(code) {
      Middleware.copyCode(code);
    },
    // Method is used for set booking value
    async setValues() {
      await BookingService.kioskGuestDetails(this.currentProps.booking.id)
        .then((booking) => {
          if (booking.is_read == false) {
            this.bookingRead();
          }
          this.customQuestions = booking.additional_question;
          this.booking = booking;
          this.currentProps.booking.status = booking.status;
          this.setBookingStatusDropDown();
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is used for set booking status drop-down
    setBookingStatusDropDown() {
      if (
        this.booking.status === "new_booking" ||
        this.booking.status === "pre_checkin"
      ) {
        if (this.checkedTodayIsCheckedIn()) {
          this.bookingStatus = [
            { status: "reservation", name: "Reservation" },
            { status: "pre_checked_done", name: "Pre Checked-In" },
            { status: "checked_in", name: "Checked In" },
            { status: "no_show", name: "No Show" },
          ];
        } else {
          this.bookingStatus = [
            { status: "reservation", name: "Reservation" },
            { status: "pre_checked_done", name: "Pre Checked-In" },
            { status: "checked_out", name: "Checked Out" },
            { status: "cancelled", name: "Cancelled" },
            { status: "no_show", name: "No Show" },
          ];
        }
      } else if (this.booking.status === "reservation") {
        if (this.checkedTodayIsCheckedIn()) {
          this.bookingStatus = [
            { status: "pre_checked_done", name: "Pre Checked-In" },
            { status: "checked_in", name: "Checked In" },
            { status: "no_show", name: "No Show" },
          ];
        } else {
          this.bookingStatus = [
            { status: "pre_checked_done", name: "Pre Checked-In" },
            { status: "checked_out", name: "Checked Out" },
            { status: "cancelled", name: "Cancelled" },
            { status: "no_show", name: "No Show" },
          ];
        }
      } else if (this.booking.status === "pre_checked_done") {
        if (this.checkedTodayIsCheckedIn()) {
          this.bookingStatus = [
            { status: "checked_in", name: "Checked In" },
            { status: "no_show", name: "No Show" },
          ];
        } else {
          this.bookingStatus = [
            { status: "checked_out", name: "Checked Out" },
            { status: "cancelled", name: "Cancelled" },
            { status: "no_show", name: "No Show" },
          ];
        }
      } else if (this.booking.status === "checked_in") {
        this.bookingStatus = [{ status: "checked_out", name: "Checked Out" }];
      } else if (this.booking.status === "cancelled") {
        this.bookingStatus = [
          { status: "cancelled", name: "Cancelled" },
          { status: "no_show", name: "No Show" },
        ];
      } else if (this.booking.status === "checked_out") {
        this.bookingStatus = [{ status: "checked_out", name: "Checked Out" }];
      } else {
        this.bookingStatus = [{ status: "no_show", name: "No Show" }];
      }
    },
    // Method is used for check check-in date is today or not
    checkedTodayIsCheckedIn() {
      let date = moment().format("YYYY-MM-DD");
      if (localStorage.last_audit) {
        date = localStorage.getItem("last_audit");
        date = moment(date).format("YYYY-MM-DD");
      }
      if (
        moment(this.currentProps.booking.check_in_date).format("YYYY-MM-DD") ==
        date
      ) {
        return true;
      } else {
        return false;
      }
    },
    // Method is used for update booking status as read
    bookingRead() {
      BookingService.updateBooking(this.currentProps.booking.id, {
        is_read: true,
      })
        .then((response) => {
          this.$root.$emit("bookingIsRead", {
            bookingId: this.currentProps.booking.id,
            status: true,
          });
        })
        .catch((error) => {
          this.$root.$emit("bookingIsRead", {
            bookingId: this.currentProps.booking.id,
            status: false,
          });
          errorHandler(error);
        });
    },
    // Method is used for update booking status
    updateBookingBasedOnStatus(bookingData) {
      BookingService.updateBooking(this.currentProps.booking.id, bookingData)
        .then((response) => {
          Middleware.notification(
            "Status updated successfully !!",
            "success",
            2000
          );
          this.bookings = response;
          this.currentProps.booking = response;
          this.$root.$emit("updateBookingStatus", {
            bookingStatus: this.booking.status,
            booking: this.booking,
          });
          this.setBookingStatusDropDown();
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is used for update booking status action
    updateBookingStatus(status) {
      // Pre check in Done Status
      this.beforeChangeStatus = status;
      if (status === "pre_checked_done") {
        Swal.fire({
          title: "Are you sure ?",
          text: "You won't be able to revert this.",
          icon: "info",
          showCancelButton: true,
          confirmButtonColor: "#238dfa",
          cancelButtonColor: "#f46a6a",
          confirmButtonText: "Yes, change it!",
        }).then((result) => {
          if (result.value) {
            this.setBookingStatusDropDown();
            let bookingData = new FormData();
            bookingData.append("status", status);
            bookingData.append("is_pre_checkin_done", true);
            this.updateBookingBasedOnStatus(bookingData);
          }
        });
      }
      // Reservation status
      else if (status === "reservation") {
        if (this.booking.allotted_room == null) {
          return Middleware.notification(
            "Please allocate room first !!",
            "info"
          );
        }
        Swal.fire({
          title: "Please allocate rooms first",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#238dfa",
          cancelButtonColor: "#f46a6a",
          confirmButtonText: "Yes, change it!",
        }).then((result) => {
          if (result.value) {
            this.setBookingStatusDropDown();

            let bookingData = new FormData();
            bookingData.append("status", status);
            this.updateBookingBasedOnStatus(bookingData);
          }
        });
      }
      // Checkin status
      else if (status === "checked_in") {
        // if (!this.booking.is_pre_checkin_done) {
        //   return Middleware.notification(
        //     "Pre check-in app steps are not completed yet !!",
        //     "info"
        //   );
        // } else {
        if (this.booking.allotted_room == null) {
          return Middleware.notification(
            "Please allocate room first !!",
            "info"
          );
        }
        Swal.fire({
          title: "Are you sure ?",
          text: "You won't be able to revert this!",
          icon: "info",
          showCancelButton: true,
          confirmButtonColor: "#238dfa",
          cancelButtonColor: "#f46a6a",
          confirmButtonText: "Yes, change it !",
        }).then((result) => {
          if (result.value) {
            this.setBookingStatusDropDown();
            let bookingData = new FormData();
            bookingData.append("status", status);
            this.updateBookingBasedOnStatus(bookingData);
          }
        });
        // }
      }
      // Check out Status
      else if (status === "checked_out") {
        // if (this.booking.current_balance !== "0.00") {
        //   return Middleware.notification("Payment not completed yet !!", "info");
        // }
        Swal.fire({
          title: "Are you sure ?",
          text: "You won't be able to revert this!",
          icon: "info",
          showCancelButton: true,
          confirmButtonColor: "#238dfa",
          cancelButtonColor: "#f46a6a",
          confirmButtonText: "Yes, change it!",
        }).then((result) => {
          if (result.value) {
            this.setBookingStatusDropDown();
            let bookingData = new FormData();
            bookingData.append("status", status);
            this.updateBookingBasedOnStatus(bookingData);
          }
        });
      }
      // Cancellation Status
      else if (status === "cancelled") {
        Swal.fire({
          title: "Are you sure ?",
          text: "You won't be able to revert this!",
          icon: "info",
          showCancelButton: true,
          confirmButtonColor: "#238dfa",
          cancelButtonColor: "#f46a6a",
          confirmButtonText: "Yes, change it!",
        }).then((result) => {
          if (result.value) {
            this.setBookingStatusDropDown();
            let bookingData = new FormData();
            bookingData.append("status", status);
            this.updateBookingBasedOnStatus(bookingData);
          }
        });
      }
      // NO Show Status
      else if (status === "no_show") {
        Swal.fire({
          title: "Are you sure ?",
          text: "You won't be able to revert this!",
          icon: "info",
          showCancelButton: true,
          confirmButtonColor: "#238dfa",
          cancelButtonColor: "#f46a6a",
          confirmButtonText: "Yes, change it!",
        }).then((result) => {
          if (result.value) {
            let bookingData = new FormData();
            bookingData.append("status", status);
            this.updateBookingBasedOnStatus(bookingData);
          }
        });
      }
    },
  },
};
</script>

<template>
  <div>
    <div class="offcanvas-header">
      <div class="d-flex align-items-center">
        <h4 class="offcanvas-title" v-if="booking !== null">Booking Details</h4>
        <div
          v-if="booking !== null"
          class="ms-3 cursor text-dark d-flex align-items-center"
          v-b-popover.hover.bottom="'click to copy'"
        >
          <p
            class="overflow-tip w-auto fs-5 fw-bold mb-0"
            @click="copyCode(booking.booking_reference)"
          >
            Ref :
            <span class="fw-medium px-1 m-0">{{
              booking.booking_reference
            }}</span>
          </p>
        </div>
      </div>
      <b-dropdown
        v-if="booking !== null"
        split
        :text="
          currentProps.booking.booking_status === 'new_booking' ||
          currentProps.booking.booking_status === 'pre_checkin'
            ? 'New Booking'
            : currentProps.booking.booking_status === 'reservation'
            ? 'Reservation'
            : currentProps.booking.booking_status === 'pre_checked_done'
            ? 'Pre Checked-In'
            : currentProps.booking.booking_status === 'checked_in'
            ? 'Checked In'
            : currentProps.booking.booking_status === 'cancelled'
            ? 'Cancelled'
            : currentProps.booking.booking_status === 'checked_out'
            ? 'Checked Out'
            : 'No Show'
        "
        :variant="
          currentProps.booking.booking_status === 'new_booking' ||
          currentProps.booking.booking_status === 'pre_checkin' ||
          currentProps.booking.booking_status === 'reservation' ||
          currentProps.booking.booking_status === 'pre_checked_done'
            ? 'outline-info'
            : currentProps.booking.booking_status === 'checked_in'
            ? 'outline-success'
            : currentProps.booking.booking_status === 'cancelled' ||
              currentProps.booking.booking_status === 'no_show'
            ? 'outline-danger'
            : currentProps.booking.booking_status === 'checked_out'
            ? 'outline-warning'
            : 'outline-secondary'
        "
      >
        <template v-for="status in bookingStatus">
          <b-dropdown-item
            :key="status.status"
            href="#"
            v-if="currentProps.booking.status !== status.status"
            @click="updateBookingStatus(status.status)"
          >
            {{ status && status.name ? status.name : "-" }}
          </b-dropdown-item>
        </template>
      </b-dropdown>
    </div>
    <div class="offcanvas-body">
      <b-tabs
        justified
        nav-class="nav-tabs-custom"
        content-class="p-2 text-muted"
      >
        <!-- Start General Details -->
        <GeneralDetails
          :currentProps="detailProps"
          @updateDetails="setValues"
          v-if="booking"
        />

        <!-- Start Payment -->
        <Payment
          :currentProps="detailProps"
          @updateDetails="setValues"
          v-if="booking"
        />

        <!-- Start upSell -->
        <UpSell
          :currentProps="detailProps"
          @updateDetails="setValues"
          v-if="booking"
        />

        <!-- Start SMS -->
        <template v-if="hotel.is_bulkvs_sms_enable">
          <SMSChat
            :currentProps="detailProps"
            @updateDetails="setValues"
            v-if="booking"
          />
        </template>

        <!-- Start Folio -->
        <!-- 
          <Folio :currentProps="detailProps" v-if="booking" />
         -->

        <!-- Start Questionnaire -->
        <template v-if="customQuestions && customQuestions.length !== 0">
          <Questionnaire
            :currentProps="detailProps"
            v-if="booking"
            :customQuestionProps="customQuestionProps"
          />
        </template>

        <!-- Start Activity Log -->
        <template>
          <ActivityLog :currentProps="detailProps" v-if="booking" />
        </template>
      </b-tabs>
    </div>
    <!-- Modal is use for display settle amount -->
    <b-modal
      id="settle-amount"
      centered
      title="Settle Amount"
      title-class="font-18"
      ref="settle-amount"
      size="lg"
    >
      <div class="row">
        <p>
          You have to pay <b>{{ no_show_item.cancellation_fee }}%</b> amount
          from your Current Balance.
        </p>
        <div class="row">
          <h6>Your Charges status are</h6>
          <hr />
          <div class="col-md-4">
            <span
              >Charges :{{ hotel.currency === "usd" ? "$" : "₹" }}
              {{ currentProps.booking.total_charge }}</span
            >
          </div>
          <div class="col-md-4">
            <span
              >Payments :{{ hotel.currency === "usd" ? "$" : "₹" }}
              {{ currentProps.booking.total_payment }}</span
            >
          </div>
          <div class="col-md-4 text-end">
            <span
              >Balance :{{ hotel.currency === "usd" ? "$" : "₹" }}
              {{ currentProps.booking.current_balance }}</span
            >
          </div>
        </div>
        <div class="row">
          <div class="col-md-5"></div>
          <div class="col-md-7 mt-2 text-end">
            <h6>
              Final Balance should be pay :
              <b
                >{{ hotel.currency === "usd" ? "$" : "₹" }}
                {{
                  parseFloat(
                    (parseFloat(no_show_item.cancellation_fee) / 100) *
                      parseFloat(currentProps.booking.current_balance)
                  ).toFixed(2)
                }}</b
              >
            </h6>
          </div>
        </div>
        <div class="row mt-2 text-end">
          <h6>
            Security Deposit amount hold :
            <b
              >{{ hotel.currency === "usd" ? "$" : "₹" }}
              {{ currentProps.booking.security_deposit_on_hold }}</b
            >
          </h6>
        </div>
        <div
          class="row"
          v-if="
            parseFloat(currentProps.booking.security_deposit_on_hold) !== 0.0
          "
        >
          <b>Notes:</b>
          <ul class="ms-4">
            <li>You can handle your charges by Security Deposit.</li>
          </ul>
        </div>
      </div>
    </b-modal>
  </div>
</template>
